
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retrenchment",
      function () {
        return require("private-next-pages/retrenchment/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retrenchment"])
      });
    }
  